export const root = "r1qpb2fy";
export const widthControl = "w2nws7s";
export const imageWrapper = "io3o5nd";
export const image = "i1goxoeq";
export const truncate = "t1yx100a";
export const divider = "d1idj6fe";
export const text = "tyozzay";
export const subtitle = "sd0fpns";
export const guidePhoto = "gue7v22";
export const notes = "n1bjq39r";
export const detailsContainer = "d15zhxma";
export const calendarIcon = "c1516iy";
export const imageDescriptor = "iqhbxdn";
export const bookmarkDescriptor = "b9x2gpd";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.tsx");